// extracted by mini-css-extract-plugin
export default {"header":"CreateCopyOfNonEditableFileModal__header--2-ALU","text":"CreateCopyOfNonEditableFileModal__text--1zlfD"};